import { MarketCode } from '@tink/config/src/markets';
import { ProductType } from '@tink/core/src/types';
import { DemoBankScenario } from '../models/demobankScenarios';
import { DemoBankClient, demoBankClient } from './demoBankClient';

export type DemobankUserFilter = {
  userMarket: MarketCode;
  userProduct: ProductType;
};

export const descriptionToProducts = (rawDescription = '') => {
  const [unparsedProducts = '', description = ''] = rawDescription.split('-');

  return {
    description,
    products: unparsedProducts
      .split(',')
      .map((product) => ProductType[product as keyof typeof ProductType])
      .filter((product: ProductType | undefined) => product),
  };
};

export const buildQueryString = (filter: DemobankUserFilter) => {
  const params = new URLSearchParams();

  if (filter.userMarket) {
    params.set('userMarketsEq', filter.userMarket);
  }

  return params.toString();
};

export const enrichUser = (user: DemoBankScenario) => ({
  ...user,
  ...descriptionToProducts(user.description),
});

const filterByProductAndMarket =
  ({ userProduct, userMarket }: DemobankUserFilter) =>
  (user: DemoBankScenario) =>
    user.products.includes(userProduct) && user.userMarkets.includes(userMarket);

export const createDemoBankService = (client: DemoBankClient) => ({
  getUsers: async (filter: DemobankUserFilter): Promise<DemoBankScenario[]> => {
    // filter on client until api is ready.
    // const queryString = buildQueryString(filter);
    const response = await client.getUsers('');
    const users = response.data;

    const filteredUsers = users.map(enrichUser).filter(filterByProductAndMarket(filter));
    const nonErrorUsers = filteredUsers.filter((user) => user.errorCondition === null);
    const errorUsers = filteredUsers.filter((user) => user.errorCondition);

    return [...nonErrorUsers, ...errorUsers];
  },
});

export const demoBankService = createDemoBankService(demoBankClient);
